import React, { useEffect, useState } from 'react';

import { DatasourceArticleLittle, DatasourceStudioLittle } from 'jamespot-user-api';

import { JRCIconButton } from 'components/JRCIconButton/JRCIconButton';

import { JRCFileFolder } from 'components/JRCFile/JRCFileFolder';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { Typography } from 'components/JRCTypography/JRCTypography.styles';
import { useIntl } from 'react-intl';

import { CSSItemWrapper, CSSItem, CSSItemLabel, CSSItemIcon } from '../../JRCWidgetDatasourceTableEditor.styles';
import { useEditorContext } from 'components/Widgets/context/hooks';
import { WidgetDatasourceContext } from '../../JRCWidgetDatasourceTableEditor';

export const StudioEditorObject = ({ uri, onHandleRemove }: { uri: string; onHandleRemove: () => void }) => {
    const intl = useIntl();
    const [datasource, setDatasource] = useState<DatasourceArticleLittle | DatasourceStudioLittle | undefined>(
        undefined,
    );
    const { handlers } = useEditorContext<WidgetDatasourceContext>();

    useEffect(() => {
        handlers.jamespot.datasource
            .getObject(uri)
            .then((response) => {
                setDatasource(response.result);
            })
            .catch(handlers.handleCatch);
    }, [uri, handlers]);

    return datasource ? (
        <>
            <Typography size={'l'}>{intl.formatMessage({ id: 'WIDGET_Datasource_Object' })}</Typography>
            <CSSItemWrapper>
                <CSSItem>
                    {datasource.mainType == 'typeApplication' ? (
                        <CSSItemIcon backgroundColor={datasource.color}>
                            <JRCIcon name={`icon-${datasource.icon}`} color={'white'} />
                        </CSSItemIcon>
                    ) : (
                        <></>
                    )}
                    {datasource.mainType === 'article' ? <JRCFileFolder size={1} mimetype={'folder/folder'} /> : <></>}
                    <CSSItemLabel>{datasource.title}</CSSItemLabel>
                    <JRCIconButton icon="icon-trash" color="orange" onClick={onHandleRemove} />
                </CSSItem>
            </CSSItemWrapper>
        </>
    ) : (
        <></>
    );
};
